import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { Species as MyType } from '@shapeable/kelp-forest-alliance-types';
const gql = String.raw;

export const Species: EntityConfig<MyType> = {
  name: 'Species',
  type: 'taxonomy',
  icon: ({ icons }) => icons.Entities.Chapter,
  autoRoutes: ['list', 'create', 'update'],
  list: {
    resultsVariant: 'grid',
    queryFields: gql`
      openGraph { id title image { id url } }
      genus { id name slug openGraph { id title image { id url } } }
      description { id text }
      banner { id name slug openGraph { id title image { id url } } }
    `,
  },
  form: {
    fields: {
      ...entityStandardFormFields,
      name: { ...entityStandardFormFields.name, label: '{{SPECIES}} Name' },
      genus: { type: "linked", entityTypeName: 'Genus', description: "What is the latin {{GENUS}} of this {{SPECIES}}?" },
      type: { type: 'linked', entityTypeName: 'SpeciesType', description: "What is the type of this {{SPECIES}}?" },
      banner: { type: 'linked', entityTypeName: 'Banner' },
      description: { type: 'longText' },

    }
  }
};